import { render, staticRenderFns } from "./StockPageHeader.vue?vue&type=template&id=d7fdaa6a&scoped=true&"
import script from "./StockPageHeader.vue?vue&type=script&lang=js&"
export * from "./StockPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./StockPageHeader.vue?vue&type=style&index=0&id=d7fdaa6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fdaa6a",
  null
  
)

export default component.exports